import React, { useRef } from 'react';
import { Form } from 'react-bootstrap';
import _ from 'lodash';
import Input from '../../Input';
import Select from '../../Select';
import AddressSearchAutocompleteInput from '../../AddressSearchAutocompleteInput/AddressSearchAutocompleteInput.view';
import { TYPES } from '../../../constants';
import { LegalInfoSectionProps } from '../LaunchingForm.types';

const LegalInfoSection = ({
  errors,
  onSelectCompanyAddress,
  formData,
  onFieldChange,
  validateField,
  normalizeVatNumber,
}: LegalInfoSectionProps) => {
  const inputElementRef = useRef<any>(null);

  return (
    <div className='mb-4'>
      <h4 className='mb-2 font-weight-bold'>Informations sur l&apos;entreprise</h4>
      <div className='mx-3'>
        <Form.Row>
          <Form.Group className='col mb-2'>
            <Input
              type='text'
              label="Nom de l'entreprise"
              id='companyName'
              placeholder='My shop'
              value={formData.legal.companyName}
              onChange={(e) => onFieldChange('legal.companyName', e.target.value)}
              onBlur={(e) => validateField('legal.companyName', e.target.value)}
              error={!!errors.legal?.companyName}
              fullWidth
              required
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group className='col mb-2'>
            <AddressSearchAutocompleteInput
              typedAddress={formData.legal.typedAddress || ''}
              setTypedAddress={(value) => {
                onFieldChange('legal.typedAddress', value);
                if (formData.legal.address) {
                  onFieldChange('legal.address', null);
                }
              }}
              handleAddressSelection={(selectedAddressValue, placeId) => onSelectCompanyAddress(selectedAddressValue, placeId)}
              handleAddressInputFormControlError={(status, clearSuggestions) => null}
              hasErrorAddressMessage={!!errors.legal?.address}
              inputElementRef={inputElementRef}
              animatePlaceholder={''}
              isFilledAddressValid={!!formData.legal.address && !!formData.legal.address.city}
              label={"Adresse de l'entreprise"}
              autoFocus={false}
              required
              onBlur={(e) => validateField('legal.typedAddress', e.target.value)}
            />
            <Form.Control.Feedback type='invalid'>
              Merci de bien séléctionner une des adresses proposées
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group className='col mb-2 mr-3'>
            <Input
              label='Numéro de SIREN'
              type='text'
              id='registreCommerceNumero'
              placeholder='123456789'
              value={formData.legal.registreCommerceNumero}
              onChange={(e) => onFieldChange('legal.registreCommerceNumero', e.target.value)}
              onBlur={(e) => validateField('legal.registreCommerceNumero', e.target.value)}
              error={!!errors.legal?.registreCommerceNumero}
              fullWidth
              required
            />
          </Form.Group>
          <Form.Group className='col ml-2 ml-3'>
            <div>
              <Select
                as='select'
                custom
                className='w-100'
                label="Type d'entreprise"
                id='companyType'
                value={formData.legal.companyType}
                onChange={(e) => onFieldChange('legal.companyType', e.target.value)}
                onBlur={(e) => validateField('legal.companyType', e.target.value)}
                error={!!errors.legal?.companyType}
                name='companyType'
                required
              >
                <option value='' disabled>
                  À choisir
                </option>
                {_.map(TYPES, type => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </Select>
            </div>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group className='col mb-2'>
            <Input
              label='Numéro de TVA intracommunautaire'
              type='text'
              id='vatNumber'
              placeholder='FR24879912806'
              value={formData.legal.vatNumber}
              onChange={(e) => onFieldChange('legal.vatNumber', normalizeVatNumber(e.target.value))}
              onBlur={(e) => validateField('legal.vatNumber', e.target.value)}
              error={!!errors.legal?.vatNumber}
              fullWidth
              required
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group className='col mb-2 mr-3'>
            <Input
              label='Capital social'
              type='number'
              id='capitalSocial'
              placeholder='500'
              value={typeof formData.legal.capitalSocial === 'number' ? String(formData.legal.capitalSocial) : (formData.legal.capitalSocial || '')}
              onChange={(e) => {
                onFieldChange('legal.capitalSocial', e.target.value);
              }}
              onBlur={(e) => validateField('legal.capitalSocial', e.target.value)}
              error={!!errors.legal?.capitalSocial}
              fullWidth
              required
            />
          </Form.Group>
          <Form.Group className='col mb-2 ml-3'>
            <Input
              label="Ville d'immatriculation"
              type='text'
              fullWidth
              id='registreCommerceVille'
              placeholder='Nice'
              value={formData.legal.registreCommerceVille}
              onChange={(e) => onFieldChange('legal.registreCommerceVille', e.target.value)}
              onBlur={(e) => validateField('legal.registreCommerceVille', e.target.value)}
              error={!!errors.legal?.registreCommerceVille}
              required
            />
          </Form.Group>
        </Form.Row>
      </div>
    </div>
  );
};

export default LegalInfoSection;
